import React from 'react';
import { Container } from 'react-bootstrap';
import { Breadcrumb, Breadcrumbs } from 'react-rainbow-components';

import "../src/css/breadCrumbs.css";

export function myBreadCrumbs(levelRoot: string, parentCat: number, childLevel: number, active: string) {

  const raiz = "Inicio";

  function category (obj: number ) {
    if ( obj == 11 || obj == 12 || obj == 13 ) {
      return (
        "certificaciónes"
      )
    } else if ( obj == 14 || obj == 15 ) {
      return (
        "cursos"
      )
    } else if ( obj == 16 ) {
      return (
        "diplomados"
      )
    } else if ( obj == 17 || obj == 18 ) {
      return (
        "postgrados"
      )
    } else if ( obj == 19 ) {
      return (
        "asistencias"
      )
    }
  }

  function categoryPath (obj: number ) {
    if ( obj == 11 || obj == 12 || obj == 13 ) {
      return (
        "/app/certificaciones"
      )
    } else if ( obj == 14 || obj == 15 || obj == 16 ) {
      return (
        "/app/cursos"
      )
    } else if ( obj == 17 || obj == 18 ) {
      return (
        "/app/posgrados"
      )
    } else if ( obj == 19 ) {
      return (
        "/app/asesorias"
      )
    }
  }

  function activeLevel (obj: number) {
    return (
      <>
        <Breadcrumb label={ category( parentCat ) } href={categoryPath( parentCat ) } /> 
      </>
    )
  }
  
  return (

    <Container className='breadcrumbs-area'>
      <div className="rainbow-p-around_large rainbow-m-bottom_xx-large rainbow-p-bottom_xx-large">
        <Breadcrumbs>
          <Breadcrumb label={ "Inicio" } href={ levelRoot } />
          { activeLevel(childLevel) }
          <Breadcrumb label={ active } disabled />
        </Breadcrumbs>
      </div>
    </Container>


  )

};

export function myBreadCrumbs2L(active: string) {

  const raiz = "Inicio";
  
  return (

    <Container className='breadcrumbs-area'>
      <div className="rainbow-p-around_large rainbow-m-bottom_xx-large rainbow-p-bottom_xx-large">
        <Breadcrumbs>
          <Breadcrumb label={ raiz } href={ "/app/" } />
          <Breadcrumb label={ active } disabled />
        </Breadcrumbs>
      </div>
    </Container>


  )

};